"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Bar3DOptions = /** @class */ (function () {
    function Bar3DOptions() {
        this.width = 500;
        this.height = 500;
        this.duration = 1000;
        this.startAngle = Math.PI / 6;
        this.scale = 20;
        this.origin = function (w, h) { return [w / 2, h / 2]; };
        this.toGroup = function (d) { return Math.min(4, Math.floor(Math.abs(d) / 2)); };
        this.data = Promise.resolve([]);
        this.textX = function (d) { return d[1] <= 1 ? d[1] : ''; };
        this.textY = function (d) { return d[1] <= 1 ? d[1] : ''; };
        this.textZ = function (d) { return d[1] <= 1 ? d[1] : ''; };
    }
    return Bar3DOptions;
}());
exports.default = Bar3DOptions;
